<template>
  <div :class="bemBlock">
    <TheProductListBreadcrumbs
      :class="bemElement('breadcrumbs')"
      :breadcrumbs="breadcrumbs"
      :breadcrumb-not-as-h1="breadcrumbNotAsH1"
    />
    <TheProductListColumnMode />
    <button :class="[bemElement('filters-button'), 'btn']" @click="openFilters">
      {{
        $msg('filters.quantity.text', 'filters', [appliedFiltersTextQuantity])
      }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getters } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';
import TheProductListBreadcrumbs from './TheProductListBreadcrumbs.vue';
import TheProductListColumnMode from './TheProductListColumnMode.vue';

export default {
  name: 'TheProductListHeader',

  components: {
    TheProductListBreadcrumbs,
    TheProductListColumnMode,
  },

  mixins: [bemClassesMixin],

  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    breadcrumbNotAsH1: {
      type: Boolean,
    },
  },

  computed: {
    ...mapGetters({
      uiNumAppliedFilters: getters.productList.uiNumAppliedFilters,
    }),
    appliedFiltersTextQuantity() {
      return this.uiNumAppliedFilters > 0 ? this.uiNumAppliedFilters : '+';
    },
  },

  methods: {
    openFilters() {
      this.$eventBus.$emit('the-product-list:open-filters');
    },
  },
};
</script>
